import { axiosCreate } from "@config/index"

const getRolesByUserLogged = async (idToken) => {
  try {
    const response = await axiosCreate.get('role/profile',
      { headers: ({ Authorization: `Bearer ${idToken}` }) }
    )

    return {
     success: true,
     ...response
    }
  } catch (error) {
    return {
      success: false,
      ...error.response
    }
  }
}

export default getRolesByUserLogged
